module.exports = __webpack_public_path__ + "static/media/orl2.png.502ffd4c.jpg";